module.exports = __webpack_public_path__ + "img/Order-Placed-Successfully.9b06cce0.png";